import { render, staticRenderFns } from "./UpsellItemCard.vue?vue&type=template&id=1761bb98&scoped=true&"
import script from "./UpsellItemCard.vue?vue&type=script&lang=js&"
export * from "./UpsellItemCard.vue?vue&type=script&lang=js&"
import style0 from "./UpsellItemCard.vue?vue&type=style&index=0&id=1761bb98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761bb98",
  null
  
)

export default component.exports